<template>
  <div>
    <Button
      :disabled="disabled"
      :icon="{ left: `gavel` }"
      @click="show = true"
      >Begin Review
    </Button>
    <Modal
      :className="$style.modal"
      label="Begin Review"
      v-model="show"
    >
      <form @submit.prevent="submit">
        <Stack direction="column" align="stretch" :class="$style.stack">
          <Select
            :options="[
              'No Preference',
              ...Object.keys(maxScores)
            ]"
            description="Select a category to review"
            label="Review Category"
            name="review_category"
            placeholder="e.g. I want to only grade..."
            v-model="category"
          />
          <Button
            :disabled="!category"
            :icon="{ left: `gavel` }"
            :loading="loading"
            >Review
          </Button>
        </Stack>
      </form>
    </Modal>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Modal from '@hackthe6ix/vue-ui/Modal';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/gavel';
  import { getCandidate } from '../../../../utils/api';
  import { maxScores } from '../../../../utils/const';

  export default {
  name: 'BeginReview',
  data() {
    return {
      maxScores,
      loading: false,
      show: false,
      category: '',
    };
  },
  methods: {
    async submit() {

      this.loading = true;

      const processedCategory = this.category === 0 ? undefined : Object.keys(maxScores)[ this.category - 1 ];

      const result = await getCandidate(processedCategory);

      if (result.success) {
        const nextID = result.data._id;

        console.log(nextID);

        this.$router.push(`/review/${nextID}${ processedCategory ? '?category=' + processedCategory : '' }`);

      } else {
        if (result.data === 'Error 404: No applications to review') {
          swal('Success', 'No more applications to review! Come back later', 'success').then(() => {
          });
        } else {
          swal('Error', result.data, 'error');
        }
      }

      this.loading = false;
      this.show = false;
    },
  },
  components: {
    Button,
    Select,
    Stack,
    Modal,
  },
};
</script>

<style lang="scss" module src="./BeginReview.module.scss" />
